export default __webpack_public_path__ + "static/media/Incorporation-of-Certificate-INSHA-BANGALES -PVT-LTD.0ada031c.jpg";